import $ from 'jquery';

const $coll = $('#comColl');
const $tabs = $coll.find('#stockTab li');
const $img = $coll.find('#stockTabImg');
const $move = $img.parent('a');
const chartInfoList = C._1CI.chartInfoList;

$tabs.on('click', function () {
  const $this = $(this);
  $tabs.filter('.on').removeClass('on');
  $this.addClass('on');
  $img.attr('src', chartInfoList[$this.index()]["img"]);
  $move.attr('href',C._1CI.chartInfoList[$this.index()]["landingUrl"]);
  var r = $this.index() + 1;
  $move.attr('onClick',`smartLog(this, "dc=1CI&p=6&r=${r}&pg=1&d=KOSPI-035720", event);`);
});


/** WEBPACK FOOTER **
 ** ./src/1CI/index.js
 **/